import { SchemaProps } from '@stack/components';

export const getLoginSchema = ({ isOtpLogin, getOTP }): SchemaProps => {
  return [
    {
      key: 'PhoneInputWithOTP',
      name: 'user_mobile',
      props: {
        fullWidth: true,
        label: 'Phone Number',
        ...(isOtpLogin && { onRequestOtp: getOTP }),
      },
    },
    // To resolve react reconciliation issue
    isOtpLogin && {
      name: 'otp_no',
      key: 'TextField',
      props: {
        sx: {
          marginTop: 8,
        },
        fullWidth: true,
        label: 'Enter 6-Digits OTP',
      },
    },
    !isOtpLogin && {
      key: 'PasswordInput',
      name: 'password',
      props: {
        sx: {
          marginTop: 8,
        },
        fullWidth: true,
        label: 'Password',
      },
    },
  ];
};
